module.exports = __webpack_public_path__ + "static/media/folder.c0a238e8.svg";